import React from "react";

/* Profile-status glyphs: one shared geometry across all three, so Listed, Claimed and Verified read as a matched set rather than three unrelated marks. */
export const StatusGlyph = ({ kind, size = 12 }) => {
  const p = {
    width: size,
    height: size,
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-hidden": true,
    focusable: "false",
  };
  if (kind === "listed") {
    return (
      <svg {...p}>
        <rect x="2.6" y="1.7" width="8.8" height="10.6" rx="1.6" stroke="currentColor" strokeWidth="1.3" />
        <path d="M4.7 4.8h4.6M4.7 7h4.6M4.7 9.2h3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      </svg>
    );
  }
  if (kind === "claimed") {
    return (
      <svg {...p}>
        <circle cx="7" cy="7" r="5.4" stroke="currentColor" strokeWidth="1.3" />
        <path d="M4.7 7.1L6.3 8.7L9.4 5.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (kind === "verified") {
    return (
      <svg {...p}>
        <circle cx="7" cy="7" r="6.1" fill="currentColor" opacity=".16" />
        <path d="M4.6 7.1L6.3 8.8L9.5 5.1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return null;
};

export default StatusGlyph;
